import { supabase } from "../lib/supabase";
import { BaseApi } from "./baseApi";

class MeetingApi extends BaseApi<T> {
  async getById(id: string) {
    const { data, error } = await supabase
      .from<T>("meeting")
      .select(
        `
        uuid,
        mentee_uuid,
        mentor_uuid,
        scheduled_time,
        duration,
        status,
        meeting_link,
        mentor_auth_token,
        mentee_auth_token,
        mentee:mentee_uuid (
          uuid,
          vincer_base_user (
            name,
            email
          )
        ),
        mentor:mentor_uuid (
          uuid,
          vincer_base_user (
            name,
            email
          )
        )
      `
      )
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    return data;
  }
}

export const meetingApi = new MeetingApi("meeting");
